const LoadingSkeleton = () => {
  return (
    <div className="flex items-center justify-center h-full min-h-96">
      <span className="loading loading-dots loading-md text-gray-400"></span>
    </div>
  );
};

export default LoadingSkeleton;
